import { InterStoreTransferStateTypes, InterStoreTransferActionTypes } from "./InterStoreTransfer.type";
import { InitPagedData, resetApiCallState } from "../Utils";

const INITIAL_STATE: InterStoreTransferStateTypes = {
    fetchAll: resetApiCallState([]),
    fetchPaged: resetApiCallState(InitPagedData),
    fetchOne: resetApiCallState({}),
};

const InterStoreTransferReducer = (
    state: InterStoreTransferStateTypes = INITIAL_STATE,
    action: any
): InterStoreTransferStateTypes => {
    switch (action.type) {
        case InterStoreTransferActionTypes.FETCH_ALL_INTER_STORE_TRANSFER:
            return {
                ...state,
                fetchAll: {
                    error: null,
                    payload: [],
                    isPending: true,
                    isSuccessful: false,
                },
            };
        case InterStoreTransferActionTypes.FETCH_ALL_INTER_STORE_TRANSFER_RESET:
            return {
                ...state,
                fetchAll: resetApiCallState([]),
            };
        case InterStoreTransferActionTypes.FETCH_ALL_INTER_STORE_TRANSFER_FAILURE:
            return {
                ...state,
                fetchAll: {
                    payload: [],
                    isPending: false,
                    isSuccessful: false,
                    error: action.payload,
                },
            };
        case InterStoreTransferActionTypes.FETCH_ALL_INTER_STORE_TRANSFER_SUCCESS:
            return {
                ...state,
                fetchAll: {
                    error: null,
                    isPending: false,
                    isSuccessful: true,
                    payload: action.payload,
                },
            };

        // ---------

        case InterStoreTransferActionTypes.FETCH_PAGED_INTER_STORE_TRANSFER:
            return {
                ...state,
                fetchPaged: {
                    error: null,
                    payload: InitPagedData,
                    isPending: true,
                    isSuccessful: false,
                },
            };
        case InterStoreTransferActionTypes.FETCH_PAGED_INTER_STORE_TRANSFER_RESET:
            return {
                ...state,
                fetchPaged: resetApiCallState(InitPagedData),
            };
        case InterStoreTransferActionTypes.FETCH_PAGED_INTER_STORE_TRANSFER_FAILURE:
            return {
                ...state,
                fetchPaged: {
                    payload: InitPagedData,
                    isPending: false,
                    isSuccessful: false,
                    error: action.payload,
                },
            };
        case InterStoreTransferActionTypes.FETCH_PAGED_INTER_STORE_TRANSFER_SUCCESS:
            return {
                ...state,
                fetchPaged: {
                    error: null,
                    isPending: false,
                    isSuccessful: true,
                    payload: action.payload,
                },
            };

        // ---------

        case InterStoreTransferActionTypes.FETCH_ONE_INTER_STORE_TRANSFER:
            return {
                ...state,
                fetchOne: {
                    error: null,
                    payload: {},
                    isPending: true,
                    isSuccessful: false,
                },
            };
        case InterStoreTransferActionTypes.FETCH_ONE_INTER_STORE_TRANSFER_RESET:
            return {
                ...state,
                fetchAll: resetApiCallState([]),
            };
        case InterStoreTransferActionTypes.FETCH_ONE_INTER_STORE_TRANSFER_FAILURE:
            return {
                ...state,
                fetchOne: {
                    payload: {},
                    isPending: false,
                    isSuccessful: false,
                    error: action.payload,
                },
            };
        case InterStoreTransferActionTypes.FETCH_ONE_INTER_STORE_TRANSFER_SUCCESS:
            return {
                ...state,
                fetchOne: {
                    error: null,
                    isPending: false,
                    isSuccessful: true,
                    payload: action.payload,
                },
            };

        default:
            return state;
    }
};

export default InterStoreTransferReducer;
